<template>
    <el-container>
        <el-main>
            <el-row style="margin-bottom: 10px">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/modules/prepare/prepare' }">分货管理</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">查看</a></el-breadcrumb-item>
                </el-breadcrumb>
            </el-row>
            <order-info :orderInfo="orderInfo" style="margin-top: 10px;margin-bottom: 10px"></order-info>
            <goods-list ref="goodsList" type="query" :orderInfo="orderInfo" :typeWaybillMode="typeWaybillMode" :data="$route.query" style="margin-bottom: 10px"></goods-list>
            <detail-list v-if="orderInfo.waybillStatus != '1' && orderInfo.waybillStatus != '5'" ref="detailList" :orderInfo="{}"></detail-list>

            <el-row style="text-align: center;margin-top: 10px">
                <el-button type="primary" @click="cancel">返回</el-button>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
import {getPrepareList} from "@/modules/server-api/prepare/prepare";
import {getApprovalDetail} from "@/modules/server-api/prepare/approvalDetail";
import goodsList from "./goodsList";
import orderInfo from "./orderInfo";
import detailList from "./detailList";

export default {
    name: "prepareInfo",
    components: {
        goodsList,
        orderInfo,
        detailList
    },
    data() {
        return {
            orderInfo: {},
            typeWaybillMode:'',
            styles:''
        }
    },
    created(){
        this.orderInfo = this.$route.query;
        this.getPriceDetailList();
        
        
    },
    mounted() {
        // this.orderInfo = this.$route.query;
        // this.getPriceDetailList();
        this.getApprovalDetailedList();
    },
    methods: {
        //获取订单信息
        async getPriceDetailList() {
            //根据入库单获取商品
            let rep = await getPrepareList.getPriceDetailList({
                orderNo: this.orderInfo.orderNo
            });
            if (rep.succ === 1) {
                let resList = rep.result.goodsList;
                this.orderInfo = rep.result.order;

                console.log('this.orderInfo',this.orderInfo)
                    // 根据状态不同，显示不同
                let string = this.orderInfo.waybillMode
                    console.log('this.orderInfo.waybillMode',this.orderInfo)
                    this.typeWaybillMode = string == '主动配货' ? '主动配货量' : '门店要货量'

                this.styles = this.orderInfo.waybillStatus != '1' ? "display:block;" : "display:none;"
                console.log('123',this.styles,this.orderInfo.waybillStatus)

                this.tableData = resList.map(item => {
                    console.log('item', item)
                    return item;
                });
                this.$refs.goodsList.addGoods( this.tableData );
            }
        },
        getApprovalDetailedList(){
            getApprovalDetail.getApprovalDetailedList({orderNo:this.orderInfo.orderNo}).then( resp => {
                if ( resp ){
                    console.log( 'getApprovalDetailedList', resp )
                    this.$refs.detailList.addDetails( resp.result.list,this.orderInfo.orderNo)
                }
            })
        },
        cancel(){
            this.$router.push({path: '/modules/prepare/prepare'}).catch(() => {
                });
        }
    }
}
</script>

<style scoped>
.detail-none{
    display: none;
}
.detail-show{
    display: block !important;
}
</style>